import { SAFE_JSON_PARSE, CAN_POST_MESSAGE } from '../consts';
import { log } from '../log';

// eslint-disable-next-line import/prefer-default-export
export const mutations = {
  SET_APP_ERROR_MESSAGE(state, data) {
    log.debug('[SET_APP_ERROR_MESSAGE]: initial %o', data);
    const [err, parsedData] = SAFE_JSON_PARSE(data); // see if we need to parse the string for json
    if ((!parsedData || err) && data) {
      log.debug('[SET_APP_ERROR_MESSAGE]: no json use original string %o', data);
      state.errorMessage = data;
    }
    if (!parsedData && (data === false || data === '')) {
      log.debug('[SET_APP_ERROR_MESSAGE]: allow falsely values to reset the field %o', data);
      state.errorMessage = '';
    }
    if (parsedData && parsedData.error) {
      log.debug('[SET_APP_ERROR_MESSAGE]: we got json %o', data);
      state.errorMessage = parsedData.error;
    }
    if (state.errorMessage) log.error('[SET_APP_ERROR_MESSAGE]: %s', state.errorMessage); // only show when setting an error not removing
  },
  SET_APP_ERROR_MESSAGE_SUBTEXT(state, data) {
    log.debug('[SET_APP_ERROR_MESSAGE_SUBTEXT]: %o', data);
    state.errorMessageSubtext = data;
    if (state.errorMessageSubtext) log.error('[SET_APP_ERROR_MESSAGE_SUBTEXT]: %s', state.errorMessageSubtext);
  },
  SET_LOADING_STATE(state, data) {
    log.debug('[SET_LOADING_STATE]: %o', data);
    state.loading = data;
  },
  SET_IS_LAUNCHPAD_OPEN(state, data) {
    log.debug('[SET_IS_LAUNCHPAD_OPEN]: %o', data);
    // we'll keep opening until it's closed once
    if (!data) sessionStorage.removeItem('clickedInstallMyServers');
    state.isLaunchpadOpen = data;
  },
  SET_IS_PROMO_OPEN(state, data) {
    log.debug('[SET_IS_PROMO_OPEN]: %o', data);
    state.isPromoOpen = data;
  },
  // server
  SET_STATE(state, data) {
    log.debug('[SET_STATE]: %o', data);
    state.state = data;
  },
  SET_CONFIG(state, data) {
    log.debug('[SET_CONFIG]: %o', data);
    state.config = data;
  },
  /**
   * @note follow specific order when committing mutations for
   * - `CHANGE_GUID_REGISTERED`
   * - `CHANGE_GUID_VALID` is watched in Index.vue to see if we should redirect
   * the user to Sign In or Up after validating their GUID in the pop-up. And this
   * conditional relies on the value set by `CHANGE_GUID_REGISTERED` aka `state.guidRegistered`
   */
  CHANGE_GUID_REGISTERED(state, data) { // put before CHANGE_GUID_REGISTERED when committing
    log.debug('[CHANGE_GUID_REGISTERED]: %o', data);
    state.guidRegistered = data;
  },
  CHANGE_GUID_VALID(state, data) { // put after CHANGE_GUID_REGISTERED when committing
    log.debug('[CHANGE_GUID_VALID]: %o', data);
    state.guidValid = data;
  },
  CHANGE_GUID_VALIDATION_RUNNING(state, data) {
    log.debug('[CHANGE_GUID_VALIDATION_RUNNING]: %o', data);
    state.guidValidationRunning = data;
  },
  CHANGE_GUID_FOR_VALIDATION(state, data) {
    log.debug('[CHANGE_GUID_FOR_VALIDATION]: %o', data);
    state.guidForValidation = data;
  },
  CHANGE_GUID_BLACKLISTED(state, data) {
    log.debug('[CHANGE_GUID_BLACKLISTED]: %o', data);
    state.guidBlacklisted = data;
  },
  CHANGE_REPLACEABLE(state, data) {
    log.debug('[CHANGE_REPLACEABLE]: %o', data);
    state.replaceable = data;
  },
  // Universal Pop-up Window
  CHANGE_POP_UP_WINDOW(state, data) {
    log.debug('[CHANGE_POP_UP_WINDOW]: %o', data);
    state.isPopUpOpen = !!data;
    state.regAtOpen = null; // always reset as `STATE_AT_OPEN` is used after we reset
  },
  STATE_AT_OPEN(state, data) {
    state.regAtOpen = data;
  },
  /**
   * @name MUTATE_KEYSERVER_RESPONSE
   * @description stores response data from key server submissions
   * @param {Object} state - Vuex state
   * @param {Object} res - response from Key Server
   * @param {string} res.apikey - 64 random chars
   * @param {boolean} res.validated
   * @param {string} res.license - url to license file
   * @param {string} res.email
   * @param {string} res.action - "recovery|new"
   */
  MUTATE_KEYSERVER_RESPONSE(state, res) {
    log.debug('[MUTATE_KEYSERVER_RESPONSE]: %o', res);
    if (res.license) state.license = res.license;
    if (res.newKey) state.keyfile = res.newKey;
    if (res.trial) state.keyfile = res.trial;
    if (res.apikey) state.apikey = res.apikey;
    if (res.validated) state.ipsValidated = res.validated;
    if (res.email) state.userEmail = res.email;
    if (res.password) state.userPassword = res.password;
    if (res.action || res.keyServerAction) state.keyServerAction = res.action || res.keyServerAction;
    if (res.username) state.username = res.username;
    if (res.avatar) state.avatar = res.avatar;
  },
  /**
   * @name SET_TRIAL
   * @description
   * @param {object} state - vuex state https://vuex.vuejs.org/guide/state.html
   * @param {string} trial
   */
  SET_TRIAL(state, res) {
    log.debug('[SET_TRIAL]: %o', res);
    state.license = res.license;
    state.keyfile = res.trial;
    state.keyServerAction = 'extendTrial';
  },
  /**
   * @name SET_USER_EMAIL
   * @description
   * @param {object} state - vuex state https://vuex.vuejs.org/guide/state.html
   * @param {string} email
   */
  SET_USER_EMAIL(state, email) {
    log.debug('[SET_USER_EMAIL]: %s', email);
    state.userEmail = email;
  },

  SET_FULL_SERVER_STATE(state, data) {
    log.debug('[SET_FULL_SERVER_STATE] start %o', data);
    // @TODO - UPC error state b/c we can't set state……?
    if (!data) return log.error('[SET_FULL_SERVER_STATE] No state data…🤬');
    let mutateData = data;
    if (mutateData.registered || mutateData.registered === 0) mutateData.registered = Boolean(Number(mutateData.registered)); // convert potential strings to number then to boolean @see: https://stackoverflow.com/a/45175346/3215809
    if (mutateData.hasRemoteApikey || mutateData.hasRemoteApikey === 0) mutateData.hasRemoteApikey = Boolean(Number(mutateData.hasRemoteApikey));
    if (mutateData.email) { // vuex store expects userEmail
      mutateData = {
        ...mutateData,
        userEmail: mutateData.email,
      };
      delete mutateData.email;
    }
    log.debug('[SET_FULL_SERVER_STATE] ✨ mutateData ✨ %o', { state, mutateData });
    state = Object.assign(state, mutateData); // eslint-disable-line
    return true;
  },

  /**
   * When we're in the pop-up we want to save the raw server state received from the postMessage.
   * This way we can troubleshoot raw server state data without having to worry about overwritting it.
   *
   * This means we'll only use this mutation when setting server state in the pop-up. So it won't be used
   * every time SET_FULL_SERVER_STATE is used. Like when setting state in the UPC.
   *
   * Usage example: there's no GUID passed to the pop-up so when we validate the GUID we change to state = 'EBLACKLISTED1'.
   * But perhaps that's not the true 'regState' of the server. But we need to overwrite the server state in the
   * pop-up so that the user can't sign in. But we still want to know the original 'regState' of the server at pop-up open.
   */
  SET_RAW_SERVER_STATE(state, data) {
    if (!CAN_POST_MESSAGE) return log.debug('[SET_RAW_SERVER_STATE] ❌ skipped not needed in non-pop-up ❌  %o', { CAN_POST_MESSAGE });
    state.rawServerState = data;
    return log.debug('[SET_RAW_SERVER_STATE] %o', data);
  },

  SIGN_OUT(state) {
    log.debug('[SIGN_OUT]: %s', '✨');
    state.registered = false;
    state.license = '';
    state.keyfile = '';
    state.apikey = '';
    state.ipsValidated = false;
    state.userEmail = '';
    state.userPassword = '';
    state.username = '';
    state.avatar = '';
  },

  SUBMISSION_FROM(state, val) {
    log.debug('[SUBMISSION_FROM]: %s', val);
    state.submissionFrom = val;
  },

  SET_WANIP(state, val) {
    log.debug('[SET_WANIP]: %s', val);
    state.wanip = val;
    sessionStorage.setItem('upc_wanip', val);
  },

  SET_SERVERDESC(state, val) {
    log.debug('[SET_SERVERDESC]: %s', val);
    state.serverdesc = val;
  },

  SET_SITE(state, val) {
    log.debug('[SET_SITE]: %s', val);
    state.site = val;
  },

  SET_CSRF(state, val) {
    log.debug('[SET_CSRF]: %s', val);
    state.csrf = val;
  },

  LICENSE_PINGBACK(state, val) { // this is reset to null when first arriving on Success. So that we prime ourselves to receive values for `licenseAction`
    log.debug('[LICENSE_PINGBACK]: %o', val);
    state.licenseAction = val;
  },

  ACCOUNT_PINGBACK(state, val) { // this is reset to null when first arriving on Success. So that we prime ourselves to receive values for `accountAction`
    log.debug('[ACCOUNT_PINGBACK]: %o', val);
    state.accountAction = val;
  },
  /**
   * @param {DateTimeStamp} val – feed it `Date.now()` as this will trigger the watcher of `receivedSuccessNewServerState` in Success.vue to trigger `this.loading = false`
   */
  RECEIVED_SUCCESS_NEW_SERVERSTATE(state, val) {
    log.debug('[RECEIVED_SUCCESS_NEW_SERVERSTATE]: %o', val);
    state.receivedSuccessNewServerState = val;
  },

  SET_UPTIME(state, val) {
    log.debug('[SET_UPTIME]: %s', val);
    state.uptime = val;
  },

  SET_EXPIRE_TIME(state, val) {
    log.debug('[SET_EXPIRE_TIME]: %s', val);
    state.expiretime = val;
  },

  SET_REGWIZ_TIME(state, val) {
    log.debug('[SET_REGWIZ_TIME]: %s', val);
    state.regWizTime = val;
  },

  CHANGE_GUID_FORUMACCOUNT(state, val) {
    log.debug('[CHANGE_GUID_FORUMACCOUNT]: %s', val);
    state.forumaccount = val;
  },

  SET_LOCALE(state, val) {
    log.debug('[SET_LOCALE]: %s', val);
    state.locale = val;
  },

  LOCALE_MESSAGES(state, val) {
    const [err, data] = SAFE_JSON_PARSE(decodeURIComponent(val));
    if (err) log.warn('[LOCALE_MESSAGES]: %o', err);
    else {
      log.debug('[LOCALE_MESSAGES]: %o', data);
      state.messages = data;
    }
  },

  SET_API_KEY(state, val) {
    log.debug('[SET_API_KEY]: %s', val);
    state.apikey = val;
  },

  SET_GRAPH_ONLINE(state, val) {
    log.debug('[SET_GRAPH_ONLINE]: %o', val);
    state.graphOnline = val;
  },

  SET_GRAPH_RECONNECTED(state, val) {
    log.debug('[SET_GRAPH_RECONNECTED]: %o', val);
    state.graphReconnected = val;
  },

  SET_MY_SERVERS(state, val) {
    log.debug('[SET_MY_SERVERS]: %o', val);
    state.myServers = [...val];
  },
  SET_MY_SERVERS_LOADING(state, val) {
    log.debug('[SET_MY_SERVERS_LOADING]: %o', val);
    state.myServersLoading = val;
  },
  SET_MY_SERVERS_ERROR(state, val) {
    if (!val) log.debug('[SET_MY_SERVERS_ERROR] unset');
    else log.error('[SET_MY_SERVERS_ERROR]: %o', val);
    state.myServersError = val ? val.replace('Graphql', 'unraid-api').replace('offline', 'stopped') : null; // the user won't know what `Graphql` is
  },
  SET_MY_SERVERS_ERROR_SHOW_SUPPORT_BTN(state, val) {
    log.debug('[SET_MY_SERVERS_ERROR_SHOW_SUPPORT_BTN]', val);
    state.myServersErrorShowSupportBtn = val;
  },
  SET_MY_SERVERS_ENV(state, val) {
    log.debug('[SET_MY_SERVERS_ENV]: %o', val);
    state.myServersEnv = val;
  },
  SET_MY_SERVERS_API_VERSION(state, val) {
    log.debug('[SET_MY_SERVERS_API_VERSION]: %o', val);
    state.apiVersion = val;
  },

  TRIGGER_UPC(state, val) {
    log.debug('[TRIGGER_UPC]: %o', val);
    state.triggerUPC = val;
  },

  /** for support of 6.10 webgui without plugin included */
  SET_HIDE_MY_SERVERS(state, val) {
    log.debug('[SET_HIDE_MY_SERVERS]: %o', val);
    state.hideMyServers = !!val; // ensure its a boolean
  },
  SET_PLG_PATH(state, val) {
    if (val !== 'dynamix.my.servers') return log.warn('[SET_PLG_PATH] value not allowed', val);
    log.debug('[SET_PLG_PATH]: %o', val);
    state.plgPath = val;
    return true;
  },
  // detect postMessage errors
  SET_POST_MESSAGE_ERROR(state, data) {
    state.postMessageError = data;
    if (state.postMessageError) log.error('[SET_POST_MESSAGE_ERROR]: %o', state.postMessageError);
  },
  // subscription
  SET_OWNER(state, data) {
    log.debug('[SET_OWNER]: %o', data);
    state.username = data && data.username ? data.username : '';
    state.avatar = data && data.avatar ? data.avatar : '';
    state.registered = !!(data && data.username);
  },
  // registration
  SET_REGISTRATION_SUB(state, data) {
    log.debug('[SET_REGISTRATION_SUB]: %o', data);
    if (data.keyfile) state.keyfile = data.keyFile.contents;
    if (data.expiration) state.expiretime = data.expiration;
  },
  SET_DEV_MODE(state, data) {
    log.debug('[SET_DEV_MODE]: %o', data);
    state.devEnv = data;
  },
  SET_SIGN_OUT_TRIGGERED(state, data) {
    log.debug('[SET_SIGN_OUT_TRIGGERED]: %o', data);
    state.signOutTriggered = data;
  },
  SET_API_EXECUTE_RESPONSE(state, val) {
    log.debug('[SET_API_EXECUTE_RESPONSE]: %o', val);
    state.apiReport = val;
  },
  SET_MY_SERVERS_CLOUD(state, val) {
    log.debug('[SET_MY_SERVERS_CLOUD]: %o', val);
    state.cloud = val;
  },
  /**
   * @name SET_REPLACE_KEY
   * @description
   * @param {object} state - vuex state https://vuex.vuejs.org/guide/state.html
   * @param {string} trial
   */
  SET_REPLACE_KEY(state, res) {
    log.debug('[SET_REPLACE_KEY]: %o', res);
    state.license = res.license;
    state.keyfile = res.newkey;
    state.keyServerAction = 'replace';
  },
  SET_PIRATE_KEY(state, res) {
    log.debug('[SET_PIRATE_KEY]: %s', res);
    state.pirateKey = !!res; // convert to boolean as that's all we need
    if (state.pirateKey) sessionStorage.setItem('upc_yargMatey', res);
    else sessionStorage.removeItem('upc_yargMatey');
  },

  SET_PROCESS_STARTED(state, res) {
    log.debug('[SET_PROCESS_STARTED]: %s', res);
    state.processStarted = res;
  },

  SET_SHOW_POST_MESSAGE_STATUS(state, res) {
    log.debug('[SET_SHOW_POST_MESSAGE_STATUS]: %s', res);
    state.showPostMessageStatus = res;
  },

  SET_KEY_INSTALLING(state, res) {
    log.debug('[SET_KEY_INSTALLING]: %s', res);
    state.keyInstalling = res;
  },

  SET_KEY_INSTALL_SUCCESS(state, res) {
    log.debug('[SET_KEY_INSTALL_SUCCESS]: %s', res);
    state.keyInstallSuccess = res;
  },

  SET_KEY_INSTALL_FAIL(state, res) {
    log.debug('[SET_KEY_INSTALL_FAIL]: %s', res);
    state.keyInstallFail = res;
  },

  SET_REGISTER_SUCCESS(state, res) {
    log.debug('[SET_REGISTER_SUCCESS]: %s', res);
    state.registerSuccess = res;
  },

  SET_REGISTER_FAIL(state, res) {
    log.debug('[SET_REGISTER_FAIL]: %s', res);
    state.registerFail = res;
  },

  SET_UNREGISTER_SUCCESS(state, res) {
    log.debug('[SET_UNREGISTER_SUCCESS]: %s', res);
    state.unregisterSuccess = res;
  },

  SET_UNREGISTER_FAIL(state, res) {
    log.debug('[SET_UNREGISTER_FAIL]: %s', res);
    state.unregisterFail = res;
  },

  /**
   * SET_JWTS
   * @param {*} state
   * @param {object} res
   * @param {string} res.accessToken
   * @param {string} res.idToken
   * @param {string} res.refreshToken
   */
  SET_JWTS(state, res) {
    log.debug('[SET_JWTS]: %s', res);
    if (!res) {
      state.accessToken = '';
      state.idToken = '';
      state.refreshToken = '';
      localStorage.removeItem('upc_accessToken');
      localStorage.removeItem('upc_idToken');
      localStorage.removeItem('upc_refreshToken');
      return;
    }
    state.accessToken = res.accessToken ? res.accessToken : '';
    state.idToken = res.idToken ? res.idToken : '';
    state.refreshToken = res.refreshToken ? res.refreshToken : '';
    if (res.accessToken) localStorage.setItem('upc_accessToken', res.accessToken);
    if (res.idToken) localStorage.setItem('upc_idToken', res.idToken);
    if (res.refreshToken) localStorage.setItem('upc_refreshToken', res.refreshToken);
  },
};
